import React from "react";
import ExpeditionGear from "../components/expedition-gears/ExpeditionGear";
import EssentialGears from "../components/expedition-gears/EssentialGears";
import ExpeditionBackpack from "../components/expedition-gears/ExpeditionBackpack";
import BrandingGear from "../components/expedition-gears/BrandingGear";
import ExpeditionLoadSystem from "../components/expedition-gears/ExpeditionLoadSystem";
import Cta from "../components/expedition-gears/Cta";

// const ExpeditionGearPage = () => {
//   return (
//     <section className="relative w-full min-h-screen text-white overflow-hidden">
//        <PackingInformation />
//     </section>
//   );
// };

const ExpeditionGearPage = () => {
  return (
    <>
      <ExpeditionGear />
      <EssentialGears />
      <ExpeditionBackpack />
      <ExpeditionLoadSystem />
      <BrandingGear />
      <Cta />
    </>
  );
};

export default ExpeditionGearPage;